/*------------------------------------*\
    TABS
\*------------------------------------*/
class Tabs {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.tabs = self.elem.querySelectorAll('[data-tabs-tab]');
        self.panels = self.elem.querySelectorAll('[data-tabs-panel]');
    }

    init() {
        let self = this;

        self.initTabs();
    }

    initTabs() {
        let self = this;

        // Add click handler to each tab
        [...self.tabs].map(tab => {

            // Tab click event handler
            tab.addEventListener('click', evt => {
                evt.preventDefault();

                self.activateTab(tab);
            });
        });

        // Activate first tab
        self.activateTab(self.tabs.item(0));
    }

    activateTab(tab) {
        let self = this;

        // Get the related panel
        let panelId = tab.getAttribute('href').substr(1);
        let panel = document.getElementById(panelId);

        // Get all other tabs
        let otherTabs = [...self.tabs].filter(item => item !== tab);

        // Get all other panels
        let otherPanels = [...self.panels].filter(item => item !== panel);

        // Deactivate other tabs
        [...otherTabs].map(item => {
            item.classList.remove('is-active');
            item.setAttribute('aria-selected', false);
        });

        // Activate the tab
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', true);

        // Activate the tab
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', true);

        // Close other panels
        [...otherPanels].map(item => {
            item.classList.remove('is-active');
            item.classList.remove('show');
        });

        // Open the panel
        panel.classList.add('is-active');

        // Force a re-paint
        let reflow = panel.offsetHeight;

        // Fade in the panel
        panel.classList.add('show');
    }
}

export default Tabs;
